import { usePermissions } from "./use-permissions";
import { PermissionsView } from "./view-permissions";

/** Liga o ViewModel à View da aba Permissões. */
export function PermissionsScreen() {
  const vm = usePermissions();

  return <PermissionsView {...vm} />;
}

export type * from "./types-permissions";
